import React, { Component } from "react";
import { bool, func } from "prop-types";
import compose from "ramda/src/compose";
import _map from "lodash/map";
import _includes from "lodash/includes";
import ClearChannelIntermittentForm from "./Intermittent/ClearChannelIntermittentForm";
import FormCheckListClearChannel from "./Unavailable/FormCheckListClearChannel";
import { translate } from "react-i18next";
import { Modal, FloatLabelSelect } from "shared/components";
import IconRepair from "assets/svg/icone-reparo-modal.svg";

const REASONS = {
  INTERMITTENT: "Circuito intermitente/performance",
  UNAVAILABLE: "Circuito indisponivel",
  ALREADY_NORMALIZED: "Causa de Queda já normalizada",
};
class ModalClearChannel extends Component {
  state = {
    productLine: REASONS.INTERMITTENT,
  };

  onChangeProductLine = (e) => {
    const { value } = e.target;
    this.setState({ productLine: value });
  };

  getOptions() {
    return _map(REASONS, (reason) => {
      return {
        value: reason,
        label: reason,
      };
    });
  }

  render() {
    const {
      t,
      isCurrentStep,
      onPreviousStep,
      onNextStep,
      onReset,
    } = this.props;
    const { productLine } = this.state;

    return (
      <Modal
        isOpen={isCurrentStep}
        onClose={onReset}
        title={t("MSG_0194")}
        icon={IconRepair}
        ariaHideApp={false}
      >
        <FloatLabelSelect
          label={t("MSG_0216")}
          name="reason"
          value={this.state.productLine}
          options={this.getOptions()}
          onChange={(e) => this.onChangeProductLine(e, "productId")}
        />

        {_includes([REASONS.INTERMITTENT], productLine) && (
          <ClearChannelIntermittentForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={this.state.productLine}
          />
        )}

        {_includes([REASONS.UNAVAILABLE], productLine) && (
          <FormCheckListClearChannel
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={this.state.productLine}
          />
        )}

        {_includes([REASONS.ALREADY_NORMALIZED], productLine) && (
          <FormCheckListClearChannel
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={this.state.productLine}
            failureDate={true}
          />
        )}
      </Modal>
    );
  }
}

ModalClearChannel.propTypes = {
  onCreateIncident: func.isRequired,
  onReset: func.isRequired,
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
  isOpen: bool,
};

ModalClearChannel.defaultProps = {
  isOpen: false,
};

const enhance = compose(translate());

export default enhance(ModalClearChannel);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalClearChannel/index.js